import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import Button from "../../../atoms/Button";
import { ISurveyAnswers, IStudent, IClass } from "../../../state";
import { generateFullName } from "../../../libs/Util";
import { questionnairePath } from "../../../teacherStore";
import RadarChart from "../../../atoms/RadarChart";

import styles from "./QuestionnaireStatistics.module.scss";

export type Props = {
  survey_answers: ISurveyAnswers[];
  survey_answers_per_teaching_material: ISurveyAnswers[];
  class_name: string;
  student?: IStudent;
};

const QuestionnaireStatistics: React.FC<Props> = ({
  survey_answers,
  survey_answers_per_teaching_material,
  class_name,
  student,
}) => {
  const history = useHistory();
  const location = useLocation<{ student: IStudent; currentClass: IClass }>();

  return (
    <div className={styles.wrapper}>
      <div className={styles.info}>
        <p className={styles.class}>
          {generateFullName([
            student?.last_name_kana,
            student?.first_name_kana,
          ])}
        </p>
        <p className={styles.name}>
          {generateFullName([student?.last_name, student?.first_name])}
        </p>
        <p className={styles.class}>クラス: {class_name}</p>
      </div>
      <div className={styles.wrapperExplainSurvey}>
        このアンケートは、エナジードの教材を使った授業の実施前と教材の完了ごとに行うものです。1~5までの数字は「点数」ではなく、高ければ良いというわけではありません。今の自分に当てはまるものを素直に記入してください。
      </div>
      <Button
        className={styles.button}
        name="アンケート一覧に戻る"
        variant="normal"
        onClick={() =>
          history.push(`${questionnairePath}/${student?.id}`, location.state)
        }
      />
      <RadarChart
        survey_answers={survey_answers}
        survey_answers_per_teaching_material={
          survey_answers_per_teaching_material
        }
        isTeacher
      />
      <div className={styles.wrapperExplainChart}>
        ※右側にある「授業前アンケート / 授業後アンケート」をそれぞれタップする
        <br />
        ことで各グラフの表示 / 非表示をコントロールすることができます。
      </div>
    </div>
  );
};

export default QuestionnaireStatistics;
